module.exports = __webpack_public_path__ + "static/img/12.6b94e0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/12.png
// module id = A8m2
// module chunks = 0